import { hasMessage } from '../../lib';
import { MessageListItem } from '../../types';

export function shouldExists (messages: MessageListItem[], ...newItems: MessageListItem[]) {
  return newItems.some(m => hasMessage(messages, m));
}

export function shouldNotExists (messages: MessageListItem[], ...newItems: MessageListItem[]) {
  return !shouldExists(messages, ...newItems);
}

export function validate (message: string, rule: () => null|void|boolean|undefined) {
  if (process.env.NODE_ENV === 'production') return;
  const isValid = execute(rule);
  if (!isValid) throw new TypeError(message);
}

function execute (x: () => null|void|boolean|undefined) {
  try { return x?.(); } catch { return false; }
}
